/** @flow */
import React, { type ComponentType } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { SectionItem } from "../section";
import ComboBox from "../combobox";
import TextField from "../text-field";
import ToggleButton from "../toggle-button";
import Checkbox from "../checkbox";
import Icon from "../icon";
import { DatePicker } from "@components";

// WARNING: DONT USE IT IN REDUX FORM
// WARNING: USE THESE INSTEAD /src/components/form/index.js

export const renderSectionDatePickerField: ComponentType<*> = ({
  label,
  input: { onChange, value },
  required,
  ...custom
}) => (
  <SectionItem
    label={
      required ? (
        <div>
          {label}
          <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
        </div>
      ) : (
        label
      )
    }
    form={<DatePicker value={value} onChange={onChange} {...custom} />}
    editable
  />
);

export const renderSectionTextField: ComponentType<*> = ({ label, input, required, ...custom }) => (
  <SectionItem
    label={
      required ? (
        <div>
          {label}
          <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
        </div>
      ) : (
        label
      )
    }
    form={<TextField {...input} {...custom} />}
    editable
  />
);
export const renderSectionToggleField: ComponentType<*> = ({
  label,
  input,
  required,
  items,
  ...custom
}) => (
  <SectionItem
    label={
      required ? (
        <div>
          {label}
          <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
        </div>
      ) : (
        label
      )
    }
    form={
      <ToggleButton
        {...input}
        {...custom}
        items={items.map(item => ({ ...item, active: item.value === input.value }))}
      />
    }
    editable
  />
);
export const renderSectionComboBox: ComponentType<*> = ({
  label,
  input: { onChange, value },
  required,
  ...custom
}) => (
  <SectionItem
    label={
      required ? (
        <div>
          {label}
          <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
        </div>
      ) : (
        label
      )
    }
    form={<ComboBox onChange={onChange} value={value} {...custom} />}
    editable
  />
);

export const renderMultiSelect: ComponentType<*> = ({
  label,
  input: { onChange, value },
  required,
  ...custom
}) => (
  <SectionItem
    label={
      required ? (
        <div>
          {label}
          <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
        </div>
      ) : (
        label
      )
    }
    form={
      <Typeahead
        {...custom}
        className="multiple-typeahead-select"
        labelKey="label"
        onChange={data => onChange(data.length ? data.map(item => item.value) : [])}
        defaultSelected={(value || []).map(item => ({ value: item, label: item }))}
        multiple
      />
    }
    editable
  />
);

export const renderCheckbox: ComponentType<*> = ({ input, ...custom }) => (
  <Checkbox {...input} {...custom} />
);
export const renderTextField: ComponentType<*> = ({ label, input, ...custom }) => (
  <TextField {...input} {...custom} />
);
export const renderToggleField: ComponentType<*> = ({ input, items, ...custom }) => (
  <ToggleButton
    {...input}
    {...custom}
    items={items.map(item =>
      item.value === input.value
        ? {
            ...item,
            active: true,
          }
        : item,
    )}
  />
);
export const renderComboBox: ComponentType<*> = ({
  label,
  input: { onChange, value },
  ...custom
}) => <ComboBox onChange={onChange} value={value} {...custom} />;

export const mapStepSubmitToReduxForm = (Component: ComponentType<*>) => ({
  handleSubmit,
  ...rest
}: any) => (
  <Component
    {...rest}
    onSubmit={(data, _, props) => {
      handleSubmit(data, props.valid != null ? props.valid : true);
    }}
  />
);

export const mapJSONSchemaErrorToRedux = (errors: Array<any> = []) =>
  errors === true
    ? {}
    : errors.reduce(
        (target, error) =>
          Object.assign(target, {
            [error.params[Object.keys(error.params)[0]]]: error.message,
          }),
        {},
      );
